import { RaceDetail } from 'src/types/race';

const SubabaseFields = {
  id: 'Id',
  race_track_id: 'RaceTrackId',
  sub_id: 'SubId',
  time_val: 'TimeVal',
  completed: 'Completed',
  is_cancelled: 'IsCancelled',
  is_deleted: 'IsDeleted',
  is_dog: 'IsDog',
  is_gallop: 'IsGallop',
  is_longterm: 'IsLongterm',
  is_open: 'IsOpen',
  is_trot: 'IsTrot',
  number: 'Number',
  schedule_time_utc: 'ScheduleTimeUtc',
  schedule_time_utc_timestamp: 'ScheduleTimeUtcTimestamp',
  start_time_utc: 'StartTimeUtc',
  start_time_utc_timestamp: 'StartTimeUtcTimestamp',
  status: 'Status',
  betting_type_name_list: 'BettingTypeNameList',
  event_date: 'EventDate',
  event_id: 'EventId',
  is_p_m_u: 'IsPMU',
  is_result: 'IsResult',
  listing_date: 'ListingDate',
  tendering_text: 'TenderingText',
  title: 'Title',
  track: 'Track',
  track_code: 'TrackCode',
  type_text: 'TypeText',
  is_manual_race_result: 'IsManualRaceResult',
  runners: 'runners',
  has_manuel_betting_type: 'HasManuelBettingType',
  manuel_betting_types: 'ManuelBettingTypes',
  annex: 'Annex',
  betting_types: 'BettingTypes',
  category_text: 'CategoryText',
  country: 'Country',
  currency: 'Currency',
  distance_metric: 'DistanceMetric',
  dotation: 'Dotation',
  races: 'Races',
  result_max_position: 'ResultMaxPosition',
  sub_type_text: 'SubTypeText',
  total_starter: 'TotalStarter',
  info_surface: 'InfoSurface',
  is_normal: 'IsNormal',
  start_mode: 'StartMode',
  surface: 'Surface',
  created_at: 'CreatedAt',
  updated_at: 'UpdatedAt',
  deleted_at: 'DeletedAt',
  coupons_calculation_triggered: 'CouponsCalculationTriggered',
};

export const RaceTransformData = (wrongData) => {
  const returnData = {} as RaceDetail;

  Object.keys(wrongData).forEach((key) => {
    if (SubabaseFields[key]) {
      returnData[SubabaseFields[key]] = wrongData[key];
    }
  });

  if (
    wrongData.result_results ||
    wrongData.result_final_position ||
    wrongData.result_non_runner
  ) {
    const resultObject = {} as any;
    wrongData.result_final_position &&
      (resultObject.final_position = wrongData.result_final_position);
    wrongData.result_non_runner &&
      (resultObject.non_runner = wrongData.result_non_runner);
    wrongData.result_results &&
      (resultObject.results = wrongData.result_results);

    returnData.Result = resultObject;
  }

  if (returnData.ListingDate) {
    returnData.ListingDate = new Date(returnData.ListingDate).toISOString();
  }
  if (returnData.EventDate) {
    returnData.EventDate = new Date(returnData.EventDate).toISOString();
  }
  if (returnData.ScheduleTimeUtc) {
    const date = new Date(returnData.ScheduleTimeUtc);
    returnData.ScheduleTimeUtc = date
      .toISOString()
      .replace('T', ' ')
      .slice(0, -5);
  }

  return returnData;
};
